export default __webpack_public_path__ + "static/media/ceramol-acn3-actiseb-mousse-360.355041bf.png";